import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useParams } from "react-router-dom";
import { FAMILY_ID_BY_SUMMARY } from "utils/apiRoutes";
import { paletteLightTheme } from "utils/ColorTheme";
import { moneyCommaSeparator, numberToCurrency } from "utils/MathFunction";
import { QueryKeys } from "utils/queryKey";

const FamilyCard = () => {
  const { id } = useParams<{ id: string }>();

  const { data: familySummaryData } = useFetchQuery({
    key: [QueryKeys.FAMILY_SUMMARY],
    route: FAMILY_ID_BY_SUMMARY(id),
  });

  // const { isFetching: xirrLoading, refetch: refreshXirr } = useFetchQuery({
  //   route: FAMILY_REFRESH_XIRR(id),
  //   key: ["GET_FAMILY_REFRESH"],
  //   enabled: false,
  //   success: () => {
  //     refetchQuery("familySummary");
  //   },
  // });

  return (
    <TableContainer>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              sx={{
                p: "16px !important",
                borderBottom: "none",
                borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
              }}
              width={"20%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Net Contribution
              </Typography>
              <Typography fontWeight={600} fontSize={18}>
                {numberToCurrency(familySummaryData?.data?.netContribution)}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                p: "16px !important",
                borderBottom: "none",
                borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
              }}
              width={"20%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Invested Value
              </Typography>
              <Typography fontWeight={600} fontSize={18}>
                {numberToCurrency(familySummaryData?.data?.investedValue)}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                p: "16px !important",
                borderBottom: "none",
                borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
              }}
              width={"20%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Current Value
              </Typography>
              <Typography fontWeight={600} fontSize={18}>
                {numberToCurrency(familySummaryData?.data?.currentValue)}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                p: "16px !important",
                borderBottom: "none",
                borderRight: `solid 1px ${paletteLightTheme.palette.border.main}`,
              }}
              width={"20%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Unrealised Gain
              </Typography>
              <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Typography fontWeight={600} fontSize={18}>
                  {numberToCurrency(familySummaryData?.data?.unrealisedGain)}
                </Typography>
                <Typography
                  fontSize={10}
                  color={
                    familySummaryData?.data?.absoluteReturn > 0
                      ? paletteLightTheme.palette.success.main
                      : `var(--warning-700)`
                  }
                >
                  (
                  {moneyCommaSeparator(familySummaryData?.data?.absoluteReturn)}
                  % )
                </Typography>
              </span>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: "none",
                p: "16px !important",
              }}
              width={"20%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Today&apos;s Gain
              </Typography>
              <span
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <Typography fontWeight={600} fontSize={18}>
                  {numberToCurrency(familySummaryData?.data?.todaysGain)}
                </Typography>
                <Typography
                  fontSize={10}
                  color={
                    familySummaryData?.data?.todaysGainPercentage > 0
                      ? paletteLightTheme.palette.success.main
                      : `var(--warning-700)`
                  }
                >
                  (
                  {moneyCommaSeparator(
                    familySummaryData?.data?.todaysGainPercentage,
                  )}
                  % )
                </Typography>
              </span>
            </TableCell>
            {/* <TableCell
              sx={{
                p: "16px !important",
                borderBottom: "none",
                borderLeft: `solid 1px ${paletteLightTheme.palette.border.main}`,
              }}
              width={"16%"}
            >
              <Typography
                fontWeight={400}
                fontSize={12}
                color={"var(--neutral-500)"}
              >
                Returns
              </Typography>
              <Typography
                fontWeight={600}
                fontSize={18}
                color="var(--black)"
                display={"flex"}
                alignItems={"center"}
                gap={1}
              >
                {familySummaryData?.data?.xirr || "0"}
                <Typography
                  fontSize={12}
                  fontWeight={500}
                  color="var(--neutral-500)"
                  display="flex"
                  alignItems="center"
                  gap={1}
                  component="span"
                >
                  (*As of{" "}
                  {familySummaryData?.data?.lastXirrRefresh
                    ? dayjs(familySummaryData?.data?.lastXirrRefresh).format(
                        "DD/MM/YYYY",
                      )
                    : ""}
                  )
                  <IconButton
                    sx={{ p: 0 }}
                    disabled={xirrLoading}
                    onClick={() => refreshXirr()}
                  >
                    {xirrLoading ? (
                      <CircularProgress size={13} />
                    ) : (
                      <ReloadIcon
                        width={13}
                        style={{ color: "var(--primary-900)" }}
                      />
                    )}
                  </IconButton>
                </Typography>
              </Typography>
            </TableCell> */}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FamilyCard;
